import Smart from './Smart.vue';

export default Smart;



// WEBPACK FOOTER //
// ./src/pages/profile/views/career-guidance/components/smart/index.ts